import { render, staticRenderFns } from "./Default2.vue?vue&type=template&id=7616c681&scoped=true"
import script from "./Default2.vue?vue&type=script&lang=js"
export * from "./Default2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7616c681",
  null
  
)

export default component.exports